import React, { useContext } from 'react';
import { useAuthorization } from 'hooks';
import { Grid, FormHelperText } from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import { Button, CollapseCard } from '@totalsoft/rocket-ui';
import DriverContainer from './DriverContainer';
import { useTranslation } from 'react-i18next';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import { sequence } from '@totalsoft/change-tracking-react';
import PropTypes from 'prop-types';
import InsuranceDataContext from 'features/insuranceDocument/stepper/insuranceDataContext';
import AuthorizationCodes from 'features/common/constants/authorizationCodes';
import { CardActionsContainer } from 'components/common/CardStyles';
import FakeTextWrapper from 'components/common/FakeTextWrapper';

const DriversComponent = ({
  lens,
  defaultCountryCode,
  onToggleExpanded,
  expanded,
  onSaveDriver,
  onAddDriver,
  loading,
  error,
  onDeleteDriver,
  saveDisabled,
  addDisabled,
  validation,
  readOnly
}) => {
  const { documentTypeId, documentStateId } = useContext(InsuranceDataContext);
  const hasRightToEditDrivers = useAuthorization(AuthorizationCodes.hasRightToEditDrivers, documentTypeId, documentStateId);
  const { t } = useTranslation();
  return (
    <CollapseCard
      id='driverCollapseCard'
      icon={PeopleIcon}
      title={t('Offer.Edit.DriverData.Title')}
      expanded={expanded}
      onToggle={onToggleExpanded}
      toggleOnHeaderClick
    >
      <Grid container spacing={1}>
        <Grid item container spacing={1}>
          {!loading &&
            !error &&
            lens &&
            (lens |> sequence).map((driver, index) => {
              return (
                <DriverContainer
                  key={index}
                  index={index}
                  driver={driver}
                  defaultCountryCode={defaultCountryCode}
                  onDeleteDriver={onDeleteDriver}
                  validation={validation[index]}
                  readOnly={readOnly}
                />
              );
            })}
          {loading && <FakeTextWrapper sx={{ ml: 1, mt: 2 }} />}
          <FormHelperText error={!isValid(validation)}>{getErrors(validation)}</FormHelperText>
        </Grid>
        <CardActionsContainer mt={2} ml={1}>
          <Button
            id='drivers_addButton'
            onClick={onAddDriver}
            disabled={
              addDisabled ||
              readOnly({
                controlName: 'Driver',
                hasAuthorization: hasRightToEditDrivers
              })
            }
          >
            {t('General.Add')}
          </Button>
          {((lens |> sequence).length > 0 || !saveDisabled) && (
            <Button
              id='drivers_saveButton'
              onClick={onSaveDriver}
              disabled={
                saveDisabled ||
                readOnly({
                  controlName: 'Driver',
                  hasAuthorization: hasRightToEditDrivers
                })
              }
            >
              {t('General.Save')}
            </Button>
          )}
        </CardActionsContainer>
      </Grid>
    </CollapseCard>
  );
};

DriversComponent.propTypes = {
  lens: PropTypes.object.isRequired,
  defaultCountryCode: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.object,
  onToggleExpanded: PropTypes.func.isRequired,
  onSaveDriver: PropTypes.func.isRequired,
  onAddDriver: PropTypes.func.isRequired,
  onDeleteDriver: PropTypes.func.isRequired,
  saveDisabled: PropTypes.bool.isRequired,
  addDisabled: PropTypes.bool.isRequired,
  validation: PropTypes.object.isRequired,
  expanded: PropTypes.bool.isRequired,
  readOnly: PropTypes.func.isRequired
};

export default DriversComponent;
